module.exports = __webpack_public_path__ + "static/media/Devicon-html5-plain-wordmark.67d97895.svg";